import type { AudioType, Partner } from "@expert/shared-types";

import { getAppConfigSingleton } from "@expert/app-config";

/**
 * Returns the Amazon Connect Quick Connect (transfer-destination) ARN to conference for a partner's
 * pre-recorded disclosure in the given AudioType (English / Spanish), or `undefined` when none is
 * configured for that partner/language.
 *
 * ARNs come from per-partner app-config (`disclosureQuickConnectArns`), which is env-scoped by the
 * served AppConfig profile — so there is no env branching here. When this returns `undefined`,
 * `disclosureAudioAvailability` is false for that language, so the disclosure player never renders
 * and the flow degrades to the plain Continue button — there is no routing-profile fallback (that
 * path was removed).
 *
 * Conferencing directly to this ARN removes the dependency on the disclosure Quick Connect being
 * reachable through the agent's routing profile (and on the exact `{partner}_{AudioType}` name
 * match).
 *
 * Only partners with `disclosureQuickConnectArns` populated (today: att) get an audio disclosure;
 * enabling a new partner is a config-only change in expert-workspace-config.
 */
export function getDisclosureEndpointArn(partner: Partner, audioType: AudioType): string | undefined {
    return getAppConfigSingleton().getPartnersConfig(partner)?.disclosureQuickConnectArns?.[audioType];
}
